import { ShieldCheck, Award, CalendarCheck, Clock } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";

const fmt = (d) => (d ? new Date(d).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "");
export const BADGE_INFO = {
  "Identity Verified": "A passport or driving licence was checked against the person running this business.",
  "Insurance Verified": "A current public liability insurance certificate was checked, including its expiry date.",
  "Qualifications Verified": "Trade certificates, cards or accreditations (e.g. Gas Safe, NICEIC) were checked.",
  "Business Verified": "A Companies House record or a recent business utility bill was checked.",
  "Enhanced Verified": "All four checks (identity, insurance, qualifications and business) are approved and current.",
};

function Row({ b, details }) {
  const d = (details || []).filter((x) => x.badge === b).sort((x, y) => (y.approved_at || "").localeCompare(x.approved_at || ""))[0];
  return (
    <li className="py-2 border-t border-slate-100 first:border-0" data-testid={`badge-info-${b.split(" ")[0].toLowerCase()}`}>
      <div className="font-semibold text-sm flex items-center gap-1.5">{b === "Enhanced Verified" ? <Award size={14} className="text-amber-500" /> : <ShieldCheck size={14} className="text-sky-600" />}{b}</div>
      <p className="text-xs text-slate-600 mt-0.5">{BADGE_INFO[b] || "Checked by the MyHomelyHub team."}</p>
      {d && <div className="text-[11px] text-slate-500 mt-1 flex flex-wrap gap-x-3">{d.approved_at && <span className="flex items-center gap-1"><CalendarCheck size={11} />Checked {fmt(d.approved_at)}</span>}{d.expires && <span className="flex items-center gap-1"><Clock size={11} />Valid until {fmt(d.expires)}</span>}</div>}
    </li>
  );
}

export function BadgeExplainer({ levels, details, children }) {
  const stop = (e) => { e.preventDefault(); e.stopPropagation(); };
  return (
    <Popover>
      <PopoverTrigger asChild><button type="button" onClick={(e) => e.stopPropagation()} onMouseDown={(e) => e.stopPropagation()} className="cursor-help" aria-label="What these badges mean" data-testid="badge-explainer-trigger">{children}</button></PopoverTrigger>
      <PopoverContent className="w-80 p-4" onClick={stop} data-testid="badge-explainer">
        <div className="font-bold text-sm">What MyHomelyHub checked</div>
        <p className="text-[11px] text-slate-500 mb-1">Our verification team reviews each document by hand. Badges come off automatically if a document expires.</p>
        <ul>{levels.map((b) => <Row key={b} b={b} details={details} />)}</ul>
      </PopoverContent>
    </Popover>
  );
}
